// src/context/TimerProvider.js

import React, { useState, useEffect } from 'react';
import TimerContext from './TimerContext';
import dayjs from 'dayjs';

export const TimerProvider = ({ children }) => {
    const [isRunning, setIsRunning] = useState(false);
    const [elapsedTime, setElapsedTime] = useState(0); // in seconds
    const [startTimeFormatted, setStartTimeFormatted] = useState('00:00');
    const [currentTime, setCurrentTime] = useState('00:00');
    const [startInput, setStartInput] = useState("");
    const [endInput, setEndInput] = useState("");
    const [selectedTask, setSelectedTask] = useState('');
    const [description, setDescription] = useState('');
    const [startTime, setStartTime] = useState('00:00');
    const [endTime, setEndTime] = useState('00:00');
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const [endDate, setEndDate] = useState(dayjs());
    const [stopTime, setStopTime] = useState('00:00'); // New state for stop time

    useEffect(() => {
        let timer;
        if (isRunning) {
            timer = setInterval(() => {
                setElapsedTime(prev => prev + 1);
            }, 1000);
        } else if (!isRunning && elapsedTime !== 0) {
            clearInterval(timer);
        }
        return () => clearInterval(timer);
    }, [isRunning, elapsedTime]);

    useEffect(() => {
        const hours = Math.floor(elapsedTime / 3600);
        const minutes = Math.floor((elapsedTime % 3600) / 60);
        const seconds = elapsedTime % 60;
        setCurrentTime(`${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`);
    }, [elapsedTime]);

    const startTimer = (startTime) => {
        setIsRunning(true);
        setStartTimeFormatted(startTime || '00:00');
        setStartTime(startTime || '00:00'); // Set start time
    };

    const stopTimer = () => {
        setIsRunning(false);
        const stopTime = dayjs().format('HH:mm'); // Capture stop time
        setStopTime(stopTime); // Store stop time
        calculateDuration(); // Calculate duration when stopping
    };

    const calculateDuration = () => {
        const start = dayjs(startTime, 'HH:mm');
        const end = dayjs(stopTime, 'HH:mm');
        const durationInMinutes = end.diff(start, 'minute');
        const durationInHours = durationInMinutes / 60;
    };

    return (
        <TimerContext.Provider value={{
            isRunning,
            elapsedTime,
            currentTime,
            startTimeFormatted,
            selectedDate,
            setSelectedDate,
            startTimer,
            stopTimer,
            startInput, setStartInput,
            endInput, setEndInput,
            selectedTask, setSelectedTask,
            description, setDescription,
            startTime, setStartTime,
            endTime, setEndTime,
            endDate,
            setEndDate,
            stopTime // Provide stopTime in context
        }}>
            {children}
        </TimerContext.Provider>
    );
};
